import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChatbotTextTransferService {
  private _textFromPlayer$ = new Subject<any>();

  public get textFromPlayer$(): Observable<any> {
    return this._textFromPlayer$.asObservable();
  }

  public pushTextFromPlayer(payload: any): void {
    this._textFromPlayer$.next(payload);
  }
}
